import { IMetricInfo } from '../../metrics/models/IMetricInfo';
import { ItemCounts } from '../../ts/ServerApi/types/IUser';
import { FlowListItemInfo } from '../../ts/models/FlowInfo';
import { IDataRoleInfo } from '../../ts/models/IDataRoleInfo';
import { IDataSourceInfo } from '../../ts/models/IDataSourceInfo';
import { IProjectInfo } from '../../ts/models/IProjectInfo';
import { IPublishedConnectionInfo } from '../../ts/models/IPublishedConnectionInfo';
import { IUserInfo } from '../../ts/models/IUserInfo';
import { IViewInfo } from '../../ts/models/IViewInfo';
import { IWorkbookInfo } from '../../ts/models/IWorkbookInfo';
import { ListResult } from '../../ts/fetchers/ListResult';

export type NavigationItemValueType = OmniboxMenuItemType | MenuItemHeaderInfo | 'searchBox';

export type OmniboxMenuItemType =
  IViewInfo
  | IWorkbookInfo
  | IMetricInfo
  | IDataSourceInfo
  | FlowListItemInfo
  | IProjectInfo
  | CatalogOmniboxItem
  | IUserInfoForOmni
  | IDataRoleInfo
  | IPublishedConnectionInfoForOmni;

export enum OmniBoxItemType {
  databases = 'databases',
  dataRoles = 'dataRoles',
  datasources = 'datasources',
  flows = 'flows',
  global = 'global',
  metrics = 'metrics',
  projects = 'projects',
  publishedConnections = 'publishedConnections',
  tables = 'tables',
  users = 'users',
  views = 'views',
  workbooks = 'workbooks',
  searchbox = 'searchBox',
  sectionHeader = 'sectionHeader'
}

export type NavigationItem = {
  sectionIndex: number;
  itemIndex: number;
  type: OmniBoxItemType;
  target: NavigationItemValueType;
  left: NavigationItemValueType | null;
  right: NavigationItemValueType | null;
  up: NavigationItemValueType | null;
  down: NavigationItemValueType | null;
  total: number;
  contentId?: string;
  countInSection: number;
  countInRow: number;
}

export interface MenuItemHeaderInfo {
  headerType: OmniBoxItemType;
}

export interface Section {
  type: OmniBoxItemType;
  list: ListResult<OmniboxMenuItemType>;
}

export interface IPublishedConnectionInfoForOmni extends IPublishedConnectionInfo {
  value?: string;
}

export interface IMetricInfoForOmni extends IMetricInfo {
  value?: string;
}

export interface IUserInfoForOmni extends IUserInfo {
  ownedItemCounts?: ItemCounts;
}

export interface CatalogOmniboxItem {
  readonly id: string;
  readonly name: string;
  readonly isCertified: boolean;
  readonly workbookCount: number;
  readonly datasourceCount: number;
}
